import BaseService from '@/ecm/common/BaseService.js';

class UserContentTypeResultsOrdersService {
    baseUrl = 'user-results-config';
    save = (data) => BaseService.post({ url: `${this.baseUrl}`, data });
    update = (data, id) => BaseService.put({ url: `${this.baseUrl}/${id}`, data });
}
export default new UserContentTypeResultsOrdersService();